import React from 'react';
import {
  Edit, SimpleForm, TextInput, NumberInput, ReferenceInput, SelectInput
} from 'react-admin';

const WindTurbineWebpageTitle = ({ record }) => {
  return <span>Webpage {record ? `"${record.label}"` : ''}</span>;
};

export default (props) => (
  <Edit title={<WindTurbineWebpageTitle />} {...props} mutationMode="pessimistic">
    <SimpleForm>
      <ReferenceInput label="Wind Turbine" source="windTurbine.id" reference="windTurbines" perPage={1000}>
        <SelectInput optionText="name" disabled />
      </ReferenceInput>
      <TextInput source="label" helperText="Ce se vede pe buton, ex. 'PLC HMI'" />
      <TextInput
        source="url"
        label="URL"
        fullWidth
        helperText="Adresa completă (ex. http://192.168.100.177) - trebuie să fie accesibilă din rețeaua celui care apasă link-ul (VPN/on-site) până se implementează tunelul."
      />
      <NumberInput source="sortOrder" label="Order" defaultValue={0} helperText="Ordinea de afișare (mai mic = mai sus)" />
    </SimpleForm>
  </Edit>
);
